import React from 'react';

const Header = () => {
	return (
		<header>
			<div className='left'>
				<div className='box'>
					<h1 className='white'></h1>
					<p className='white subheader'>
						But I must explain to you how all this mistaken idea of
						denouncing pleasure and praising pain was born and I
						will give you a complete account of the system.
					</p>
					<button className='primaryLarge'>Dowiedz się więcej</button>
				</div>
			</div>
			<div className='right'>
				<div className='img'></div>
			</div>
        </header>
	);
};

export default Header;
